'use strict';

function isWebkit() {
  return 'WebkitAppearance' in document.documentElement.style;
}

module.exports = isWebkit;


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-dnd/dist-modules/utils/isWebkit.js
 ** module id = 320
 ** module chunks = 0
 **/